{
  "es": {
    "dashboard": {
      "greetings": {
        "afternoon": "Buenas tardes, {first_name}",
        "evening": "Buenas noches, {first_name}",
        "morning": "Buenos días, {first_name}",
        "night": "Buenas noches, {first_name}"
      },
      "milestones": {
        "caught_up_subtitle": "No tienes elementos pendientes ahora mismo.",
        "caught_up_title": "Estás al día",
        "completed_count": "{count} completados",
        "due_before": "Antes de {date}",
        "journey_no_active_subtitle": "Esta unidad aún no ha empezado su recorrido.",
        "journey_no_active_title": "Sin hito activo",
        "journey_select_unit_subtitle": "Elige una unidad arriba para ver su recorrido.",
        "journey_select_unit_title": "Selecciona una unidad",
        "journey_title": "Tu recorrido",
        "open_action": "Abrir",
        "previous_label": "Hitos anteriores",
        "progress_completed": "{completed} / {total} completados",
        "show_less": "Mostrar menos",
        "show_more_tasks": "Mostrar {count} tarea más | Mostrar {count} tareas más",
        "status_active": "En curso",
        "status_completed": "Completado",
        "status_planned": "Planificado",
        "todo_now_title": "Qué hacer ahora",
        "upcoming_more": "{count} hitos próximos más"
      },
      "titles": {
        "activityFeed": "Actividad reciente",
        "assignedTasks": "Mis tareas",
        "newsFeed": "Novedades",
        "ongoingTickets": "En curso",
        "openTickets": "Abiertas",
        "progress": "Progreso",
        "tickets": "Conversaciones",
        "totalTickets": "Todas las conversaciones",
        "unreadTickets": "Sin leer",
        "yourAssignedTickets": "Asignadas a ti"
      }
    }
  }
}
